module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-835-retro-min.084bea4a.jpg";